import { render } from "./veterans-welcome.vue?vue&type=template&id=0e34fc90"
import script from "./veterans-welcome.js?vue&type=script&lang=js"
export * from "./veterans-welcome.js?vue&type=script&lang=js"

import "./veterans-welcome.vue?vue&type=style&index=0&id=0e34fc90&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__